import '../sass/main.scss'
import { setupDomain } from './setup/domain.setup'
import { setupProductConfiguration } from './setup/product-configuration.setup'
import { setupProductOffer } from './setup/product-offer.setup'
import { setupBuildTagging } from '@/setup/build-tagging'
import { setupProductConfigurationPage } from './setup/product-configuration-page.setup'
import { setupDomainSearch } from './setup/domain-search.setup'

setupDomain()
setupProductOffer()
setupProductConfiguration()
setupProductConfigurationPage()
setupDomainSearch()

const rootEl = document.querySelector<HTMLElement>('#order-ryanada__cart')
if (!rootEl) {
  throw new Error('Build Tagging: Root Element Not Set')
}

setupBuildTagging(rootEl, 'cart')
